// extracted by mini-css-extract-plugin
module.exports = {"container":"TextHeader_container__1f4jd","expanded":"TextHeader_expanded__3tIl4"};